const faqArray = [
  {
    faqTitle: 'Accomodations Info',
    faqAnswer:
      'We will be providing accomodations for everyone invited to the wedding for the date range indicated above (4 days, 3 nights). We will email everyone with updates once the place and location have been finalized, the information will be found on the website. The hotel is about a 5 minute drive from the venue, and we are planning on providing the transportation to/from. ',
  },
  {
    faqTitle: 'Food Info',
    faqAnswer:
      'The hotel accomodation will also include breakfast. For the other meals during the date range, the activities we have planned will have meals included in them as well. The plan will be to ensure all meals be provided by us during the duration of the wedding weekend.',
  },
  {
    faqTitle: 'When Do I Need to RSVP By?',
    faqAnswer:
      'Given the nature of the wedding, we kindly request everyone to RSVP by September of 2025. If we have not received a response by September 30th, 2025 we will consider that you will not be able to make it, but please reach out to us directly if there is a reason you might not be able to let us know by this date.',
  },
  {
    faqTitle: 'Is There a Dress Code?',
    faqAnswer:
      'For the actual ceremony, we just want everyone to be as comfortable as possible. Think Mamma Mia wedding scene. For the rest of the trip, in Etna it will be cooler than in Catania, due to the elevation gain. The weather should be favorable in Etna, but hotter in Catania. Keep this in mind, and bring whatever would suit you best!',
  },
  {
    faqTitle: 'Can I Bring a Plus One?',
    faqAnswer:
      'Due to the very small size of the wedding, only those explicitly named in the invitation are invited.',
  },
  {
    faqTitle: 'Why Italy? But also, yay Italy!!',
    faqAnswer:
      'It was never our intention to do a destination wedding. However, after our second trip to Italy in September of 2024, we fell in love with the Etna region and decided a wedding weekend with a smaller group of people in a country we both love so much, was much more our style.',
  },
  {
    faqTitle: 'Is There a Registry?',
    faqAnswer:
      'Since we know a plane ticket to Italy is a big expense, not only financially but time-wise, we have decided to not have a registry. Your presence to our celebration is all we ask for, and we cannot wait to celebrate with everyone :)',
  },
  {
    faqTitle: 'So...when do I need to get there?',
    faqAnswer:
      'The food/accomodations we will be providing begin on Thursday July 30th in Catania. Our plan is to meet and greet everyone at a restaurant for dinner and drinks,and then make our way to the town of Etna afterwards. We highly encourage folks to come earlier, or stay later in Europe after the wedding, however after the four day period, guests will have to provide their own food/accomodations.',
  },
  {
    faqTitle: 'Will Mr. Meelo be attending?',
    faqAnswer:
      "Unfortunately, we won't be able to bring Meelo to the celebration. This makes us very sad, but a small sacrifice to make.",
  },
  {
    faqTitle: 'What Next?',
    faqAnswer:
      "When you RSVP, we will ask you to provide a good email address that you regularly check. Since the event is so far out, there are details we don't quite have just yet (i.e name of dinner places, transporation info etc). We will be sending out communications via email when information on the site has been updated, so you may check it. It shouldn't be more than a couple of communications.",
  },
];
export default faqArray;
